"use client";

import { useLogger } from "@/lib/firelog";

export const LoggerComponent = () => {
  useLogger();
  return null;
};
